"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleTypesExcludingShuttleAndSedanLite = exports.VehicleTypesExcludingShuttle = exports.VehicleTypeDescriptions = exports.VehicleTypesCarryOns = exports.VehicleTypesSuitcases = exports.VehicleTypesCapacity = exports.VehiclePartnerApiTypeToVehicleType = exports.VehicleTypePartnerApiType = exports.VehicleTypes = exports.VehiclePartnerApiTypeNamesExcludingShuttle = exports.VehiclePartnerApiTypeNames = exports.VehiclePartnerApiType = exports.VehicleType = void 0;
var VehicleType;
(function (VehicleType) {
    VehicleType[VehicleType["Sedan"] = 0] = "Sedan";
    VehicleType[VehicleType["Mpv"] = 1] = "Mpv";
    VehicleType[VehicleType["Van"] = 2] = "Van";
    VehicleType[VehicleType["LuxurySedan"] = 3] = "LuxurySedan";
    VehicleType[VehicleType["Shuttle"] = 4] = "Shuttle";
    VehicleType[VehicleType["SedanLite"] = 100] = "SedanLite";
})(VehicleType || (exports.VehicleType = VehicleType = {}));
var VehiclePartnerApiType;
(function (VehiclePartnerApiType) {
    VehiclePartnerApiType[VehiclePartnerApiType["sedan"] = 0] = "sedan";
    VehiclePartnerApiType[VehiclePartnerApiType["mpv"] = 1] = "mpv";
    VehiclePartnerApiType[VehiclePartnerApiType["van"] = 2] = "van";
    VehiclePartnerApiType[VehiclePartnerApiType["luxury"] = 3] = "luxury";
    VehiclePartnerApiType[VehiclePartnerApiType["shuttle"] = 4] = "shuttle";
    VehiclePartnerApiType[VehiclePartnerApiType["sedanLite"] = 100] = "sedanLite";
})(VehiclePartnerApiType || (exports.VehiclePartnerApiType = VehiclePartnerApiType = {}));
exports.VehiclePartnerApiTypeNames = Object.keys(VehiclePartnerApiType).filter((key) => isNaN(Number(key)));
exports.VehiclePartnerApiTypeNamesExcludingShuttle = exports.VehiclePartnerApiTypeNames.filter((vehicle) => vehicle !== "shuttle");
exports.VehicleTypes = Object.keys(VehicleType)
    .filter((key) => !Number.isNaN(Number(key)))
    .map((i) => Number(i));
exports.VehicleTypePartnerApiType = {
    [VehicleType.Sedan]: "sedan",
    [VehicleType.Mpv]: "mpv",
    [VehicleType.Van]: "van",
    [VehicleType.LuxurySedan]: "luxury",
    [VehicleType.Shuttle]: "shuttle",
    [VehicleType.SedanLite]: "sedanLite",
};
exports.VehiclePartnerApiTypeToVehicleType = {
    ["sedan"]: VehicleType.Sedan,
    ["mpv"]: VehicleType.Mpv,
    ["van"]: VehicleType.Van,
    ["luxury"]: VehicleType.LuxurySedan,
    ["shuttle"]: VehicleType.Shuttle,
    ["sedanLite"]: VehicleType.SedanLite,
};
exports.VehicleTypesCapacity = {
    [VehicleType.Sedan]: 3,
    [VehicleType.LuxurySedan]: 2,
    [VehicleType.Mpv]: 4,
    [VehicleType.Van]: 7,
    [VehicleType.Shuttle]: 10,
    [VehicleType.SedanLite]: 3,
};
exports.VehicleTypesSuitcases = {
    [VehicleType.Sedan]: 3,
    [VehicleType.LuxurySedan]: 2,
    [VehicleType.Mpv]: 4,
    [VehicleType.Van]: 7,
    [VehicleType.Shuttle]: 10,
    [VehicleType.SedanLite]: 3,
};
exports.VehicleTypesCarryOns = {
    [VehicleType.Sedan]: 3,
    [VehicleType.LuxurySedan]: 2,
    [VehicleType.Mpv]: 4,
    [VehicleType.Van]: 7,
    [VehicleType.Shuttle]: 10,
    [VehicleType.SedanLite]: 3,
};
exports.VehicleTypeDescriptions = {
    [VehicleType.Sedan]: "Sedan comparable to a Volkswagen Passat, up to 3 passengers with luggage.",
    [VehicleType.LuxurySedan]: "Luxury sedan comparable to a Mercedes-Benz E-Class, up to 2 passengers with luggage.",
    [VehicleType.Mpv]: "Compact MPV comparable to a Volkswagen Touran, up to 4 passengers with luggage.",
    [VehicleType.Van]: "Van comparable to a Mercedes-Benz Vito, up to 7 passengers with luggage.",
    [VehicleType.Shuttle]: "Shuttle comparable to a Mercedes-Benz Vito, up to 10 passengers with luggage.",
    [VehicleType.SedanLite]: "Sedan comparable to a Volkswagen Passat, up to 3 passengers with luggage.",
};
exports.VehicleTypesExcludingShuttle = [
    VehicleType.Sedan,
    VehicleType.Mpv,
    VehicleType.Van,
    VehicleType.LuxurySedan,
    VehicleType.SedanLite,
];
exports.VehicleTypesExcludingShuttleAndSedanLite = [
    VehicleType.Sedan,
    VehicleType.Mpv,
    VehicleType.Van,
    VehicleType.LuxurySedan,
];
//# sourceMappingURL=VehicleType.js.map